import { render } from "./TicketStoreIndex.vue?vue&type=template&id=66d9fede&scoped=true"
import script from "./TicketStoreIndex.vue?vue&type=script&lang=js"
export * from "./TicketStoreIndex.vue?vue&type=script&lang=js"

import "./TicketStoreIndex.vue?vue&type=style&index=0&id=66d9fede&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-66d9fede"

export default script